import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { notify } from 'libs/common';
import { CountersListRow } from './row/counters-list-row';
import { Content, Table } from './counters-list.styled';

export const CountersList = (props) => {
  const { data, refresh } = props;

  const { t } = useTranslation();

  /**
   * del row
   * @param {*} id
   */
  const del = (id) => {
    api
      .call('client_counters.detele', { client_counter_id: id })
      .then(() => {
        notify(t('sections.Счетчики клиентов'), t('messages.Изменения сохранены'), 'success');
        refresh();
      })
      .catch((error) => {
        notify(t('sections.Счетчики клиентов'), error.toString());
      });
  };

  if (!data.length) {
    return null;
  }

  const getZonesEl = () => {
    return data.map((el, idx) => {
      const row = { ...el };
      return <CountersListRow key={idx} row={row} onDel={del} />;
    });
  };

  const zonesEl = getZonesEl();

  return (
    <Content>
      <Table>
        <thead>
          <tr>
            <th width="200">{t('tables.Парковочная зона')}</th>
            <th width="150">{t('tables.Показывать')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{zonesEl}</tbody>
      </Table>
    </Content>
  );
};
